import { startRouter } from './router.js';
import { unlockAudio, setAudioOn } from './audio.js';
import { loadAppProgress } from './storage.js';

export function boot() {
  const pr = loadAppProgress();
  setAudioOn(pr.settings?.audio !== false);

  const toast = document.getElementById('toast');
  window.addEventListener('glifo-storage-warning', () => {
    if (toast) {
      toast.hidden = false;
      toast.textContent =
        'Memoria locale non disponibile: i progressi restano solo in questa sessione.';
    }
  });

  document.body.addEventListener(
    'click',
    () => {
      unlockAudio().catch(() => {});
    },
    { once: true }
  );

  startRouter();
  try {
    globalThis.localStorage?.setItem('glifo.visited', '1');
  } catch {
    // Storage warnings are handled by the progress adapter; this marker is best-effort.
  }

  if ('serviceWorker' in navigator && import.meta.env.PROD) {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  }
}
